import type { GroupBase, StylesConfig } from 'react-select';
import type { WizardOption } from './types';

export function selectSovereignStyles<Option extends WizardOption, IsMulti extends boolean>(): StylesConfig<Option, IsMulti, GroupBase<Option>> {
  return {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? 'rgba(11,59,46,0.04)' : '#fcfaf3',
      borderColor: state.isFocused ? '#0B3B2E' : 'rgba(11,59,46,0.28)',
      borderRadius: '0.75rem',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(166,206,57,0.22)' : 'none',
      minHeight: '2.9rem',
      fontSize: '0.875rem',
      fontWeight: 500,
      color: '#0B3B2E',
      '&:hover': { borderColor: state.isDisabled ? 'rgba(11,59,46,0.28)' : 'rgba(51,146,116,0.6)' },
    }),
    menu: (p) => ({
      ...p,
      borderRadius: '0.75rem',
      border: '1px solid rgba(11,59,46,0.28)',
      background: '#FCFBF6',
      boxShadow: '0 18px 44px -20px rgba(42,31,23,0.40)',
      zIndex: 50,
    }),
    menuPortal: (p) => ({ ...p, zIndex: 99999 }),
    option: (p, state) => ({
      ...p,
      borderRadius: '0.375rem',
      backgroundColor: state.isSelected ? '#1F5A47' : state.isFocused ? 'rgba(11,59,46,0.06)' : 'transparent',
      color: state.isSelected ? '#fff' : '#2A1F17',
      fontWeight: state.isSelected ? 600 : 500,
    }),
    multiValue: (p) => ({ ...p, backgroundColor: 'rgba(51,146,116,0.12)', borderRadius: '0.5rem' }),
    multiValueLabel: (p) => ({ ...p, color: '#1F5A47', fontWeight: 600, fontSize: '0.8125rem' }),
    multiValueRemove: (p) => ({ ...p, ':hover': { backgroundColor: '#1F5A47', color: '#fff' } }),
    placeholder: (p) => ({ ...p, color: '#7C8A82' }),
    singleValue: (p) => ({ ...p, color: '#0B3B2E' }),
    dropdownIndicator: (p, state) => ({ ...p, color: state.isFocused ? '#1F5A47' : '#7C8A82' }),
    indicatorSeparator: () => ({ display: 'none' }),
  };
}
